"use strict";
import { platformHandler } from "../platforms/PlatformHandler";
import { setAuditoriumMode } from "../App/actions";

// Initializes Auditorium.
export class Auditorium {
  constructor() {
    this.lastPositionSlide = -1;
    this.isSharing = true;
  }

  action(action, data, cb, user) {
    console.log("auditorium", action);
    switch (action) {
      case "setMode":
        platformHandler.dispatch(setAuditoriumMode(data));
        var ipc = window.require("electron").ipcRenderer;
        let scope = this;

        ipc.on("setShare", function(event, msg) {
          scope.isSharing = msg;
        });
        break;

      case "pptName":
        platformHandler.setPPTName(data);
        break;

      case "slidesNotes":
        console.log("setea las notas");
        //platformHandler.setSlidesNotes( data );
        //platformHandler.setStateInitPresentation(1, 1);
        break;

      case "verifyPreviews":
        console.log('slides name', platformHandler.getPPTName() )
        platformHandler.uploadPPT( cbState => {
          console.log("cbState", cbState);
        }, true);
        break;

      case "slideShowEnds":
        /*platformHandler.sendQuestionsToExhibitor();
        platformHandler.closeCurrentSession();
        platformHandler.openScene("SelectPresentation");*/
        break;

      case "slideShowDone":
        break;

      case "slidePosition":
        if (data.position <= 0) {
          if (platformHandler.getSlideIndex() > 0) {
            return;
          }
          data.position = 1;
        }

        if (this.lastPositionSlide !== -1) {
          if (data.position !== this.lastPositionSlide) {
            platformHandler.executeCommand({
              command: "InteractionFeature",
              interactionType: "Goto",
              newIndex: data.position
            });
            //platformHandler.actionInPresentation(  );
            this.lastPositionSlide = data.position;
          }
        } else {
          this.lastPositionSlide = data.position;
        }

        break;

      case "isSharing":
        return this.isSharing;
        break;

      default:
        console.log("not implemented yet", action);
        break;
    }

    return null;
  }
}

export let auditorium = new Auditorium();


// WEBPACK FOOTER //
// ./src/containers/auditorium/Auditorium.js